import { DictionariesService } from "@sa/rep-mdm";
import { SLIDE_NUMBER } from "../constants";

export async function getUnitsDictionary(dictionariesService: DictionariesService) {
  const unitsDictionary = await dictionariesService.getDictionary({
    id: "v_dict_units_alternative_price",
    parameters: {
      attributes: "",
      slide: SLIDE_NUMBER,
    },
  });

  const unitItems = await unitsDictionary.getAll();
  const units = unitItems.map((item) => Number(item.id));

  return {
    units,
  };
}
